import { useTranslation } from 'react-i18next';

import { fetchListingStages } from '@/api/v4/project-listings.api';
import {
  projectsFilterOptionsState,
  selectedProjectsFiltersState,
} from '@/features/projects/project.state';
import { isDefaultOptionArray } from '@/helpers/other';
import { AsyncSelect } from '@/ui/select/async/async-select';
import { sharedProps } from '@/ui/select/select-shared';

import { mapListingStatusFilter } from './project-filters-helpers';
import { useAtom, useSetAtom } from 'jotai';

export const ListingStatusFilter = () => {
  const { t } = useTranslation('projects');

  const setProjectsFilters = useSetAtom(projectsFilterOptionsState);
  const [selectedFilters, setSelectedFilters] = useAtom(
    selectedProjectsFiltersState,
  );

  const setOptions = async (search: string) => {
    const listingStatuses = await fetchListingStages({
      ...(search && { search }),
    });

    const listingStatusesOptions = listingStatuses.map(mapListingStatusFilter);

    setProjectsFilters(currentFilters => ({
      ...currentFilters,
      listingStages: listingStatusesOptions,
    }));
    return listingStatusesOptions;
  };

  return (
    <AsyncSelect
      id="filter-listing-stage"
      label={t`projects.stage`}
      defaultValue={selectedFilters.listingStages}
      setOptions={setOptions}
      isMulti
      isSearchable
      onChange={option => {
        if (!isDefaultOptionArray(option)) return;

        setSelectedFilters(currentFilters => ({
          ...currentFilters,
          listingStages: option.length ? option : null,
        }));
      }}
      {...sharedProps}
    />
  );
};
